import styled from 'styled-components';
import { getSizeBy } from '@invent/wl-ui-kit';

export const PreloadBox = styled.div`
  display: flex;
  gap: ${getSizeBy(2)};
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
